import {
  SET_ONLINE_COUNTRY,
  SET_ONLINE_STATE,
  SET_ONLINE_CITY,
  SET_ONLINE_OFFER_RESTAURANT,
  SET_ONLINE_OFFER_SELECTED_RESTAURANT,
} from "../../types";

const initialState = {
  country: "",
  state: "",
  city: "",
  businessList: [],
  selectedBusinessList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ONLINE_COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case SET_ONLINE_STATE:
      return {
        ...state,
        state: action.payload,
      };
    case SET_ONLINE_CITY:
      return {
        ...state,
        city: action.payload,
      };
    case SET_ONLINE_OFFER_RESTAURANT:
      return {
        ...state,
        businessList: action.payload,
      };
    case SET_ONLINE_OFFER_SELECTED_RESTAURANT:
      return {
        ...state,
        selectedBusinessList: action.payload,
      };
    default:
      return state;
  }
}
